import rules from "../rules";

export default {
    first_name: [
        rules.required('First name')
    ],
    last_name: [
        rules.required('Last name')
    ],
    address_primary: [
        rules.required('Primary address')
    ],
    city: [
        rules.required('City'),
    ],
    state: [
        (p, model) => {
            return model.is_international_customer || ( !!p || 'State is required!');
        }
    ],
    zip: [
        (p, model) => {
            return model.is_international_customer || ( !!p || 'Zip is required!');
        }
    ],
    province: [
        (p, model) => {
            return !model.is_international_customer || (!!p || 'Province is required for international customers!');
        }
    ],
    postal_code: [
        (p, model) => {
            return !model.is_international_customer || (!!p || 'Postal Code is required for international customers!');
        }
    ],
    country: [
        (p, model) => {
            return !model.is_international_customer || (!!p || 'Country is required for international customers!');
        }
    ],
    phone: [
        rules.required('Phone')
    ],
    email: [
        rules.required('Email'),
        (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || 'Enter valid email'
    ],
    email_confirmation: [
        rules.required('Email confirmation'),
        (email, model) => (email === model.email || (model.reservation && email === model.reservation.email)) || 'Emails doesn\'t match'
    ],
    date_pickup: [
        (date, model) => !!(!!date || (model.is_seasonal || (model.reservation &&  model.reservation.is_seasonal) )) || 'Start day is required'

    ],
    date_return: [
        (date, model) => !!(!!date || (model.is_seasonal || (model.reservation &&  model.reservation.is_seasonal))) || 'End day is required'
    ],
    reservees_number: [
        rules.required('Number of renters')
    ],
    pickup_hour: [
        rules.required('Pickup hour')
    ],
}
